export const LOCALES = {
	'-': {
		// DE
		DE_AT: 'de-AT',
		DE_CH: 'de-CH',
		DE_DE: 'de-DE',
		// EN
		EN_GB: 'en-GB',
		EN_HK: 'en-HK',
		EN_IE: 'en-IE',
		EN_SG: 'en-SG',
		EN_US: 'en-US',
		// ES
		ES_ES: 'es-ES',
		// FR
		FR_BE: 'fr-BE',
		FR_CH: 'fr-CH',
		FR_DE: 'fr-DE',
		FR_FR: 'fr-FR',
		FR_LU: 'fr-LU',
		// IT
		IT_IT: 'it-IT',
		PT_PT: 'pt-PT',
		// NL
		NL_NL: 'nl-NL',
		// EL
		EL_GR: 'el-GR',
		// DA
		DA_DK: 'da-DK',
		// CS
		CS_CZ: 'cs-CZ',
	},
	_: {
		DE_AT: 'de_AT',
		DE_CH: 'de_CH',
		DE_DE: 'de_DE',
		// EN
		EN_GB: 'en_GB',
		EN_HK: 'en_HK',
		EN_IE: 'en_IE',
		EN_SG: 'en_SG',
		EN_US: 'en_US',
		// ES
		ES_ES: 'es_ES',
		// FR
		FR_BE: 'fr_BE',
		FR_CH: 'fr_CH',
		FR_DE: 'fr_DE',
		FR_FR: 'fr_FR',
		FR_LU: 'fr_LU',
		// IT
		IT_IT: 'it_IT',
		PT_PT: 'pt_PT',
		// NL
		NL_NL: 'nl_NL',
		// EL
		EL_GR: 'el_GR',
		// DA
		DA_DK: 'da_DK',
		// CS
		CS_CZ: 'cs_CZ',
	},
};

export const CURRENCY = {
	// DE
	DE_AT: 'EUR',
	DE_CH: 'CHF',
	DE_DE: 'EUR',
	// EN
	EN_GB: 'GBP',
	EN_HK: 'HKD',
	EN_IE: 'EUR',
	EN_SG: 'SGD',
	EN_US: 'USD',
	// ES
	ES_ES: 'EUR',
	// FR
	FR_BE: 'EUR',
	FR_CH: 'CHF',
	FR_FR: 'EUR',
	FR_LU: 'EUR',
	// IT
	IT_IT: 'EUR',
	PT_PT: 'EUR',
};

export const VALUE = 123456789;

export const FORMATTED_VALUES = {
	' ,00': '123 456 789,00',
	'’.00': '123’456’789.00',
	'.,00': '123.456.789,00',
	',.00': '123,456,789.00',
	' .00': '123 456 789.00',
	' ,': '123 456 789',
	'’.': '123’456’789',
	'.,': '123.456.789',
	',.': '123,456,789',
	' .': '123 456 789',
};
